module.exports = {
  changeChargeNo: '申请流水号',
  changeReason: '更改原因',
  state: '申请进度',
  jobNo: '业务编号',
  customerId: '委托单位',
  receivable: '费用类型',
  dateCreated: '申请时间',
  createdBy: '申请人',
  judgeDutyResult: '判责审核结果',
  judgeDutyDate: '判责审核时间',
  judgeDutyBy: '判责审核人',
  businessAuditResult: '商务审核结果',
  businessAuditReason: '拒绝原因',
  businessAuditDate: '商务审核时间',
  businessAuditBy: '商务审核人',
  judgeClosedResult: '关账判定',
  judgeClosedDate: '关账判定时间',
  judgeClosedBy: '关账判定人',
  returnReason: '退回原因',
  returnDate: '退回时间',
  returnBy: '退回人',
  remarks: '备注',
  details: '更改前后对比',
  revoke: '撤销申请',
  return: '退回',
  judgeDuty: '判责审核',
  businessAudit: '商务审核',
  judgeClosed: '关账判定',
  exportDetail: '导出明细',
  tabJudgeDuty: '待判责审核',
  tabBusinessAudit: '待商务审核',
  tabJudgeClosed: '待关账判定',
  tabManagerReview: '待经理审核',
  tabAll: '全部',
  dateCreatedDay: '申请日期',
  judgeDutyDateDay: '判责审核日期',
  businessAuditDateDay: '商务审核日期',
  judgeClosedDateDay: '关账判定日期',
  applyChangeCharge: '申请更改费用',
  applyAddCharge: '申请新增费用',
  applyDeleteCharge: '申请删除费用',
  showApplyChangingCharge: '查看更改费用审核',
  ChangeTheChargesInTheExpenseReview: '更改费用审核中的费用',
  actionType: '申请类型',
  confirmApplyDeleteCharge: '确认申请删除该费用吗？',
  changeReasonCannotBeNull: '更改原因不能为空.',
  changeReasonIsTooLong: '更改原因长度不能超过100.',
  judgeDutyMessage: '本次更改费用中操作人员是否有责？',
  judgeDutyYes: '有责',
  judgeDutyNo: '无责',
  businessAuditMessage: '是否同意更改费用？',
  businessAuditAgree: '同意',
  businessAuditRefuse: '拒绝',
  businessAuditReasonNotNull: '请输入拒绝原因',
  judgeClosedMessage: '本次更改费用是关账前或关账后？',
  judgeClosedBefore: '关账前',
  judgeClosedAfter: '关账后',
  returnMessage: '此申请将回到初始状态',
  returnMessageConfirm: '是否确认退回？',
  returnReasonNotNull: '请输入退回原因',
  revokeMessage: '仅可以撤销未经审批的申请，请检查',
  revokeMessageConfirm: '撤销后无法恢复，是否确认撤销？',
  modifyBefore: '修改前',
  modifyAfter: '修改后',
  estimateProfit: '整票预估利润：',
  generateByContract: '带入约价',
  generateByContractConfirm: '是否确定带入约价？',
  JudgmentResult: '判责结果',
  ChangeCharge: '更改费用',
  OnlyRejectedApplicationFormsCanBeCopied: '只能复制已拒绝的申请单',
  JudgeBeforeAndAfterAccountClosing: '判断关账前后',
  FeesIncurred: '费用产生',
  updateSuccess: '【{0}】对应未操作费用汇率更新成功',
  exchangeRates: '汇率区间发生变化，是否更新费用汇率？',
  exchangeRates2: '主票汇率区间发生变化，是否更新主小票下的费用汇率？',
  chargeLanguage: '语言描述',
  costDescription: '费用描述'
}
